import ReactPlayer from 'react-player/lazy';
import React from 'react';
import { parseLoomId } from 'utils/urlParser';
import LoomPreview from 'components/AttachmentVideoInput/LoomPreview';
import classNames from 'classnames/bind';
import styles from './VideoPlayer.module.scss';

const cx = classNames.bind(styles);

interface VideoPreviewProps {
  videoUrl: string;
}

const VideoPlayer: React.FC<VideoPreviewProps> = ({ videoUrl }) => {
  const loomId = parseLoomId(videoUrl);

  if (loomId) {
    return <LoomPreview loomId={loomId} />;
  }

  return (
    <div className={cx('player-wrapper')}>
      <ReactPlayer
        className={cx('react-player')}
        height="100%"
        url={videoUrl || ''}
        width="100%"
        controls
      />
    </div>
  );
};

export default VideoPlayer;
